
import React, { useContext, useEffect, useState } from "react";
import { ThemeContext } from "providers/ThemeProvider";
import { Container, Card } from "components/common";
import styled from "styled-components";
import { Wrapper, Grid, Item, Content } from "./styles";
import "animate.css/animate.min.css";

export const Skills = () => {
  const { theme } = useContext(ThemeContext);
  const [skill, setSkill] = useState([]);
  useEffect(() => {
    const skills = [
      {
        name: "HTML5",
        id: 1,
        img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS2bOyzc9hl7G9oSdjYP86z-EvMd0tlgRxNrd2Dxd1cxF2pkiILKKwFoV-TQkOqoJfdizo&usqp=CAU",
        level: "Intermediate"
      },
      {
        name: "CSS",
        id: 2,
        img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQA0_0s1vlr09Vq9jFwtxG-DTdbSBNVW81YlaqCUB5zKcuJq9Ap0J4bf0IywKkXfVZuda8&usqp=CAU",
        level: "Intermediate"
      },
      {
        name: "Javascript",
        id: 3,
        img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTwIy4bZqoklCCTq2PZQBXRvAclERwzG9qn4mRcbGA2OJU0YK-GKDj8X4hVaCiuu9kLSpQ&usqp=CAU",
        level: "Intermediate"
      },
      {
        name: "Typescript",
        id: 18,
        img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSl-gbOZaIll9TlMg0e9kc_J02_P6Sfqjzn4u2MlvG2GZcby_r71N09zf6mYKGin--cWX0&usqp=CAU",
        level: "Intermediate"
      },
      // {
      //   name: "Bootstrap",
      //   id: 15,
      //   img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSf-aSzPPaGyMYUdUaBjQ8AOY1_HzoQNfuUhIx7D54EP_Gy5V5yRbK3J2phKdznL6WXdD8&usqp=CAU",
      //   level: "INtermediate"
      // },
      {
        name: "NodeJs",
        id: 4,
        img: "data:image/png;base64,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",
        level: "Intermediate"
      },
      {
        name: "Express",
        id: 5,
        img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQm5k1KlR0W5PGaO0slFgnSdtQsHSJasDRFB3VRc206YnUD99E4Tc5sme9jdIxikHt39h0&usqp=CAU",
        level: "Intermediate"
      },
      {
        name: "Django",
        id: 17,
        img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSzDEj_YWPY-XQw5zKgGxzQnYcmZigfQKRzpX9dsq1P038aMCXuazpCm5M9iiv46CWE4t0&usqp=CAU",
        level: "Basic"
      },
      {
        name: "Mongodb",
        id: 6,
        img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTdmAt4trnV5GFWSIOPWCBulCvvoBrddgtqlFaTgka4XTNJ4_eiEyvcMUSOSgjqJc0M6R0&usqp=CAU",
        level: "Intermediate"
      },
      {
        name: "MySQL",
        id: 7,
        img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRO1g31Duhb-ktgFP3JjOG7CUFzNY8sCGtJ7jikZ_1l5kDnLKasWnbTYYFbAIku5NLlUX8&usqp=CAU",
        level: "Basic"
      },
      {
        name: "PostgreSQL",
        id: 17,
        img:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ8cg1TN7Lpnv4_AXulAlDV9Q-Lfvh--TTAbam-ii_HiKSD7dD7Ye6txD8AKI7dl5iPCpw&usqp=CAU",
        level: "Basic"
      },
      {
        name: "React",
        id: 8,
        img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTOnfKXV87r8CCIdCBq6g6nQOotJX9Gcxw5OZ4LkRm5UXYPwcq7tz_wtfpaEz7PjFnXU6c&usqp=CAU",
        level: "Intermediate"
      },
      {
        name: "Svelte",
        id: 19,
        img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcShunseUFTrtQBlcHnzWB7zZLHbQe1HlDn3ad8zBuTe2DDWPjqR210sXUmoJh6iL00eGpU&usqp=CAU",
        level: "Intermediate"
      },
      {
        name: "C++",
        id: 9,
        img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTDtD10_09Ny3pSEcm5iE5CEQU5FEg28oUCMs7E34RyLAZP8qzNr33-Tlrq58fa1mgJM4c&usqp=CAU",
        level: "Intermediate"
      },
      {
        name: "Python",
        id: 12,
        img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRU_xTTGQsy9OsBqdNWx57ZSuviGTmhDiWu1LMBRV632KzrlcJJ-PVQqIiYBc5Iq50NpoY&usqp=CAU",
        level: "Basic"
      },
      {
        name: "Webpack",
        id: 10,
        img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT_VN3yvHW3CPtbg4njHxR8weh4n95vCLfGZUitLiA0Qi6-dY1upQyifJ4UqdDauoiVMFs&usqp=CAU",
        level: "Basic"
      },
      {
        name: "Linux",
        id: 10,
        img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT7TC4J175DKcayKxzj33Mn2TQR5JRXBANX60jFnBdacune3ujRzwGdnc5rYsg2BU_8azk&usqp=CAU",
        level: "Basic"
      },
      {
        name: "Git",
        id: 11,
        img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQfVMxCAdlw6tvyhAi7VQ9mhimPlrpg7YKAdY2eOnVPc9ooYE6MB6REvbFa485U0n8SzdM&usqp=CAU",
        level: "Intermediate"
      },
      {
        name: "VS Code",
        id: 13,
        img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTTnHETJAGFtg0ZEUkl28jQ3aWOlWP3EGmmx0OSeJ7aI80bZVGeCJ24xH106uEOFwnFJ6s&usqp=CAU",
        level: "Intermediate"
      },
      {
        name: "Firebase",
        id: 14,
        img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTItzL9z-6ABdxw3pqw-mwVSoNZTgjJ2sdGOAcrY12e3e7yDxH1FcRVvSGWUd_O0gOXVF8&usqp=CAU",
        level: "Basic"
      },
      {
        name: "Elastic Search",
        id:15,
        img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSFMj0ui1uloNm5csVob9ChPi_aUk72NGHdX0TljyasM3gJ_jUBvYQPw3mI0qYDzfTZ27I&usqp=CAU",
        level: "Basic"
      },
      // {
      //   name: "Heroku",
      //   id:16,
      //   img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQsAjFcuKrqPf8Rk7ez6OmDqcclIxcuVwpQkAo-yN5tMLKwq_Wu8vb1gY3j_TNlvVGu-L4&usqp=CAU",
      //   level: "Intermediate"
      // },
      {
        name: "Tailwind",
        id:16,
        img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTeKPw4CK4jcH7udsFHZdiB3iIOuI3fUCsxUZosXy4Y1yd25NA-dzCBPrSDIhg1BwObl3w&usqp=CAU",
        level: "Intermediate"
      }
    ];
    setSkill(skills);
  }, []);
  const Heading = styled.h1({
    fontSize: "3rem",
    color: `rgb(228 93 93) !important`,
    '@media(max-width: 700px)': {
      fontSize: '1.5rem'
    }
  });

  return (
    <Wrapper as={Container} id="skills">
      <div>
        {<Heading>Skills</Heading>}
        <Grid id="skillgrid">
          {skill.map((node) => (
            // <ScrollAnimation animateIn="animate__slideInLeft" duration="3" >
                  <Item
                    key={node.id}
                    as="div"
                    rel="noopener noreferrer"
                    theme={theme}
                  >
                    <Card class="Card" theme={theme}>

                      <Content>
                        <div>
                          <img src={node.img} />

                        </div>
                        <h4>
                          {node.name}
                        </h4>
                      </Content>
                    </Card>
                  </Item>
              // </ScrollAnimation>
          ))}
        </Grid>
      </div>
    </Wrapper>
  );
};
